<template>
  <div>
    <!-- Main Add Card Dialog -->
    <el-dialog
      title="Thêm thẻ mới"
      :before-close="handleClose"
      :visible.sync="isOpen"
      :show-close="true"
      :close-on-click-modal="false"
      width="600px"
      top="10vh"
      custom-class="modern-dialog"
      @open="handleOpen"
    >
      <div class="dialog-header-themed">
        <div class="themed-icon"><i class="el-icon-bank-card"></i></div>
        <div class="themed-text">
          <h3>THÊM THẺ NHẬN DIỆN MỚI</h3>
          <p>Chọn trường học, thiết bị AI đọc thẻ và quét số thẻ để tạo mới thông tin.</p>
        </div>
      </div>

      <el-form
        label-position="top"
        :model="formData"
        :rules="rules"
        ref="formData"
        class="modern-dialog-form"
      >
        <div class="form-section">
          <h4 class="section-divider"><i class="el-icon-setting"></i> Cấu hình gán thẻ</h4>
          
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="Chọn trường học liên kết">
                <el-select
                  v-model="formData.idSchool"
                  filterable
                  clearable
                  placeholder="Chọn trường"
                  class="w-full"
                >
                  <el-option
                    v-for="item in schoolList"
                    :key="item.id"
                    :value="item.id"
                    :label="`${item.id} - ${item.schoolName}`"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="Chọn thiết bị AI đọc thẻ" prop="idDevice">
                <el-select
                  v-model="formData.idDevice"
                  filterable
                  placeholder="Chọn thiết bị nhận diện đọc thẻ"
                  class="w-full"
                  @change="getUserRecognition"
                >
                  <el-option
                    v-for="item in listDevice"
                    :key="item.id"
                    :value="item.id"
                    :label="`${item.id} - ${item.nameDevice}`"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="form-section">
          <h4 class="section-divider"><i class="el-icon-cpu"></i> Quét mã số thẻ (RFID)</h4>
          
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="Mã số thẻ quét được" prop="cardNumber">
                <el-input
                  v-model.trim="formData.cardNumber"
                  readonly
                  placeholder="Click nút 'Đọc thẻ' và quét thẻ từ trên thiết bị..."
                  class="card-number-input"
                >
                  <template #append>
                    <el-button type="primary" @click="handleGetNumberCard" class="read-card-btn">
                      <i class="el-icon-radar"></i> Đọc thẻ từ
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <template #footer>
        <div class="dialog-footer-themed">
          <el-button type="danger" plain size="medium" icon="el-icon-circle-close" @click="handleClose">
            Đóng
          </el-button>
          <el-button type="success" size="medium" icon="el-icon-circle-check" :loading="loading.submit" @click="submitForm">
            Lưu lại
          </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- RFID Scanner Radar Modal -->
    <el-dialog
      title="Quét thẻ nhận diện"
      :visible.sync="showWarning"
      width="420px"
      top="25vh"
      :show-close="true"
      custom-class="radar-dialog"
    >
      <div class="radar-container">
        <div class="radar-signal-rings">
          <div class="ring ring-1"></div>
          <div class="ring ring-2"></div>
          <div class="ring ring-3"></div>
          <div class="radar-center-icon">
            <i class="el-icon-bank-card"></i>
          </div>
        </div>
        
        <div class="radar-status-info">
          <h4>{{ contentDevice }}</h4>
          <p>Hãy chạm thẻ từ của bạn vào vùng cảm biến RFID trên thiết bị AI để hệ thống tự động ghi nhận mã số thẻ.</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cardManagerService from "@/services/ManagerRecognition/CardManagerService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "AddCardDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: () => false
    },
    schoolList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      formData: {
        idSchool: "",
        idDevice: "",
        cardNumber: "",
        usageStatus: "not use"
      },
      listDevice: [],
      contentDevice: "ĐANG CHỜ QUÉT THẺ TỪ...",
      showWarning: false,
      rules: {
        idDevice: [
          { required: true, message: "Thiết bị không được để trống", trigger: "change" }
        ],
        cardNumber: [
          { required: true, message: "Số thẻ không được để trống", trigger: "change" }
        ]
      },
      loading: {
        submit: false
      }
    };
  },

  methods: {
    async handleOpen() {
      try {
        const response = await cardManagerService.getListDeviceRecognition();
        this.listDevice = response.data.data || [];
        if (this.listDevice.length > 0) {
          this.formData.idDevice = this.listDevice[0].id;
        }
      } catch (err) {
        console.error("Failed to load devices:", err);
      }
    },

    async handleGetNumberCard() {
      if (!this.formData.idDevice) {
        this.$message.warning("Vui lòng chọn thiết bị đọc thẻ trước!");
        return;
      }
      this.contentDevice = "ĐANG CHỜ QUÉT THẺ TỪ...";
      this.showWarning = true;
      
      try {
        const response = await cardManagerService.getInformationNumberCard(this.formData.idDevice);
        if (response.data.status === 200) {
          this.showWarning = false;
          this.formData.cardNumber = response.data.data;
          NotifyMessage.leftCornerNotificationSuccess("Đọc mã số thẻ thành công!");
        } else {
          this.contentDevice = "LỖI ĐỌC THẺ THIẾT BỊ!";
        }
      } catch (error) {
        console.error(error);
        this.contentDevice = "KẾT NỐI ĐỌC THẺ THẤT BẠI!";
      } finally {
        this.handleCloseCard();
      }
    },

    handleClose() {
      this.formData = {
        idSchool: "",
        idDevice: "",
        cardNumber: "",
        usageStatus: "not use"
      };
      this.$refs["formData"].resetFields();
      this.$emit("closeDialog");
    },

    async submitForm() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          try {
            const checkResp = await cardManagerService.checkNumberCardAllDeviceRecognition(this.formData.cardNumber);
            if (checkResp.data.status === 200) {
              if (checkResp.data.data === true) {
                NotifyMessage.leftCornerNotificationError("Thẻ đã tồn tại trên hệ thống!");
              } else {
                const createResp = await cardManagerService.createCardRecognition({
                  ...this.formData,
                  idSchool: this.formData.idSchool ? parseInt(this.formData.idSchool) : 0
                });
                if (createResp.data.data === true) {
                  NotifyMessage.leftCornerNotificationSuccess("Tạo mới thẻ thành công!");
                  this.handleClose();
                } else {
                  NotifyMessage.leftCornerNotificationError("Tạo mới thẻ thất bại!");
                }
              }
            }
          } catch (error) {
            console.error(error);
            NotifyMessage.leftCornerNotificationError("Lỗi hệ thống khi lưu thẻ!");
          } finally {
            this.loading.submit = false;
          }
        }
      });
    },

    getUserRecognition() {
      // Empty handler to mimic behavior from original template
    },

    handleCloseCard() {
      // Empty handler to mimic behavior from original template
    }
  }
};
</script>

<style lang="scss">
/* Modern styling for dialog headers and layouts */
.modern-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;

  .el-dialog__header {
    display: none; /* Custom header used instead */
  }

  .el-dialog__body {
    padding: 0 !important;
  }
}

/* Radar Scan Dialog */
.radar-dialog {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0,0,0,0.2) !important;
  
  .el-dialog__header {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    padding: 16px 20px;
    font-weight: 700;
  }
  
  .el-dialog__body {
    padding: 24px !important;
  }
}
</style>

<style lang="scss" scoped>
.dialog-header-themed {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #fff;

  .themed-icon {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.25);
    font-size: 20px;
  }

  .themed-text {
    h3 {
      margin: 0 0 4px 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    p {
      margin: 0;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.modern-dialog-form {
  padding: 24px 28px;
}

.form-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;

  .section-divider {
    margin: 0 0 16px 0;
    font-size: 13px;
    font-weight: 700;
    color: #3b82f6;
    display: flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 8px;
  }
}

/deep/ .el-form-item {
  margin-bottom: 16px;

  .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding: 0 0 4px 0 !important;
    font-size: 13px;
  }
  
  .el-input__inner {
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    &:focus {
      border-color: #3b82f6;
    }
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
    font-weight: 700;
    font-family: Consolas, Monaco, monospace;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
}

.read-card-btn {
  background-color: #3b82f6 !important;
  color: white !important;
  font-weight: 600;
  border-radius: 0 6px 6px 0 !important;
  margin: -10px -20px !important;
  border: none;
  &:hover {
    background-color: #2563eb !important;
  }
}

.dialog-footer-themed {
  padding: 16px 28px;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.w-full {
  width: 100%;
}

/* Scanning Radar Animation */
.radar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0;
}

.radar-signal-rings {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
}

.radar-center-icon {
  width: 54px;
  height: 54px;
  background: #3b82f6;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 26px;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

.ring {
  position: absolute;
  border: 2px solid #60a5fa;
  border-radius: 50%;
  opacity: 0;
  animation: radarWave 2.5s infinite linear;
}

.ring-1 { animation-delay: 0s; }
.ring-2 { animation-delay: 0.8s; }
.ring-3 { animation-delay: 1.6s; }

@keyframes radarWave {
  0% {
    width: 54px;
    height: 54px;
    opacity: 0.8;
  }
  100% {
    width: 120px;
    height: 120px;
    opacity: 0;
  }
}

.radar-status-info {
  text-align: center;
  
  h4 {
    margin: 0 0 8px 0;
    font-size: 15px;
    font-weight: 700;
    color: #1e3c72;
    letter-spacing: 0.5px;
    animation: textFlash 1.5s infinite ease-in-out;
  }
  
  p {
    margin: 0;
    font-size: 12px;
    color: #64748b;
    line-height: 1.6;
  }
}

@keyframes textFlash {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}
</style>